export default "__VITE_ASSET__7NgiBCg9__"